module.exports = __webpack_public_path__ + "static/media/notification.09681e24.svg";